export default __webpack_public_path__ + "fonts/9bc247d080a85648c02b2a2c7c2913c7.svg";